import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,Dialog,ImageViewer,
  Button,Selector,Ellipsis,Image,SideBar,NavBar,Tabs,FloatingBubble,Grid,Swiper,List,Popup,TextArea
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { MessageOutline, LikeOutline,BellOutline,MessageFill,UploadOutline,ExclamationCircleFill,DeleteOutline } from 'antd-mobile-icons'
import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { environment } from '../../service/baseUrl';
import {
    GetAlbumsById,SaveUserAction,PostUserAction,DelAlbumsById
  } from '../../service/service';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            planetId: 0,
            fileList: [],

            tabIdx: 0,
            navIdx: 0,

            isShow: false,
            visible: false,
            visible1: false,
            demoImages: [],

            albumsInfo: {},
            userInfo: {},
            isAdmin: false,

            textArea: "",
            userAction: [],
            pId: null,
            pUserName: "",
        };
    }

    componentDidMount() {
        var that = this;
        const { location } = this.props;
        const { planetId, id } = location.state || {}; // 获取 URL 参数
        this.setState({
            planetId: planetId,
            id: id,
        }, () => {
            this.loadUserAction()
        })

        var user = localStorage.getItem("user");

        if (id) {
            GetAlbumsById(id).then(res => {
                if (res.success) {
                    var result = res.result;

                    var list = []
                    result.imgs.map((item, index) => {
                        if (item.indexOf("https://") > -1) {
                            list.push({
                                key: 999 - index,
                                url: item,
                                thumbnailUrl: item,
                            })
                        } else {
                            list.push({
                                key: 999 - index,
                                url: environment.apiEndpoint + item,
                                thumbnailUrl: environment.apiEndpoint + item,
                            })
                        }
                    })

                    var isAdmin = false;
                    if (result.creatorUserId == JSON.parse(user).id || result.creatorPlanetUserId == JSON.parse(user).id) {
                        isAdmin = true;
                    }
                    result.userActionDto.map(item => {
                        if (item.userActionId == JSON.parse(user).id && item.isRead) {
                            isAdmin = true;
                        }
                    })
                    that.setState({
                        id: id,
                        imgName: result.headImg,
                        albumsInfo: result,
                        fileList: list,
                        isAdmin
                    })
                }
            })
        }
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })

    }

    submitForm = (data) => {
        var that = this;
        SaveUserAction(data).then(res => {
            if (res.success) {
                that.setState({
                    visible: false,
                    textArea: "",
                    pUserName: "",
                    pId: null,
                })
                that.loadUserAction();
            }
        })
    }
    
    loadUserAction = () => {
        var that = this;
        var data = {
            TableType: "Album",
            TableId: this.state.id,
            Type: 1,
        };
        PostUserAction(data).then(res => {
            if (res.success) {
                res.result.map(item => {
                    //item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                    if (item.headImg != null) {
                        if (item.headImg.indexOf("https://") > -1) {
                            var urls = item.headImg.split("https://").filter(Boolean);
                            item.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                        } else {
                            item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                        }
                    }

                    const creationTime = new Date(item.creationTime); 
                    item.creationTime = that.formatTimeDifference(creationTime);

                    var cUserActionDto = item.cUserActionDto;
                    item.zanCount = item.cUserActionDto.filter(action => action.type === 2).length;
                    item.yanCount = item.cUserActionDto.filter(action => action.type === 1).length;
                    item.cUserActionDto = cUserActionDto.filter(action => action.type === 1);
                    item.yanList = cUserActionDto.filter(action => action.type === 2);
                })
                that.setState({
                    userAction: res.result
                })
            }
        })
    }

    formatTimeDifference(creationTime) {
        const now = new Date();
        const timeDiff = now - creationTime; // 时间差（毫秒）
        const diffInSec = Math.floor(timeDiff / 1000);
        const diffInMin = Math.floor(diffInSec / 60);
        const diffInHours = Math.floor(diffInMin / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInSec < 60) {
            return "刚刚";
        } else if (diffInMin < 60) {
            return `${diffInMin}分钟前`;
        } else if (diffInHours < 24) {
            return `${Math.max(1, diffInHours)}小时前`; // 不足1小时显示"1小时前"
        } else if (diffInDays < 3) {
            return `${diffInDays}天前`;
        } else {
            // 超过3天显示具体日期（如 "2023-05-15"）
            return new Date(Date.now() - timeDiff).toLocaleDateString("zh-CN");
        }
    }


    render() {

        const colors = ['#ace0ff', '#bcffbd', '#e4fabd', '#ffcfac']

        const items = colors.map((color, index) => (
            <Swiper.Item key={index}>
                <div style={{ background: color, height: "450px" }}>
                    <Image src={"https://api.weibinyi.com/images/niannian/4/35-09.png"}
                        width={"100%"} height={"450px"} fit='cover' />
                </div>
            </Swiper.Item>
        ))


        const showDialog = () => {
            Dialog.show({
                title: (
                    <div style={{
                        textAlign: 'center',
                        fontSize: 18,
                        color: '#595959',
                        padding: '8px 0',
                        marginTop: "25px",
                        fontFamily: '"STKaiti", "KaiTi", serif' // 楷体字体
                    }}>
                        <ExclamationCircleFill style={{
                            color: '#ff4d4f',
                            fontSize: 24,
                            marginRight: 8
                        }} />
                        确认删除此段回忆？
                </div>
                ),
                content: (
                    <div style={{
                        textAlign: 'center',
                        color: '#8c8c8c',
                        padding: '12px 0 16px',
                        fontSize: 14,
                        paddingBottom: "10px",
                        paddingTop: "0px",
                        fontFamily: '"STKaiti", "KaiTi", serif'
                    }}>
                        删除后将无法恢复
                </div>
                ),
                actions: [
                    [
                        {
                            key: 'cancel',
                            text: (
                                <span style={{
                                    display: 'inline-block',
                                    width: '100%',
                                    color: '#8c8c8c',
                                    fontSize: 16,
                                    letterSpacing: 2,
                                    fontFamily: '"STKaiti", "KaiTi", serif'
                                }}>
                                    取 消
                      </span>
                            ),
                            style: {
                                borderRight: '1px solid #f0f0f0'
                            },
                            onClick: () => {
                                console.log('回忆已随风消散...')
                                Dialog.clear()
                            }
                        },
                        {
                            key: 'delete',
                            text: (
                                <span style={{
                                    display: 'inline-block',
                                    width: '100%',
                                    color: '#ff4d4f',
                                    fontSize: 16,
                                    letterSpacing: 2,
                                    fontWeight: 'bold',
                                    fontFamily: '"STKaiti", "KaiTi", serif'
                                }}>
                                    删 除
                      </span>
                            ),
                            onClick: () => {
                                var that = this;
                                DelAlbumsById(that.state.albumsInfo.id).then(res => {
                                    if (res.success) {
                                        if(res.result){
                                            that.props.navigate('/albumClass', {
                                                replace: true,
                                                state: { id: that.state.planetId }
                                            }); // 传递状态
                                        }
                                    }
                                })
                            }
                        }
                    ]
                ],
                style: {
                    '--border-radius': '12px',
                    '--max-width': '280px',
                    '--adm-font-size-main': '16px'
                },
                bodyStyle: {
                    padding: 0
                },
                closeOnMaskClick: true,  // 新增这行，点击遮罩层可关闭
                closeOnAction: true     // 确保点击按钮后也关闭
            })
        }
          

        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/albumClass', { replace: true, state: { id: this.state.planetId } }); // 传递状态
                }}>
                    详情
                </NavBar>

                <div style={{ margin: "3%", width: "94%", marginTop: "0px" }}>
                    <Swiper
                        indicatorProps={{
                            color: 'white',
                        }}
                        autoplay loop
                        autoplayInterval={3000}
                        defaultIndex={0}
                    >
                        {
                            this.state.fileList.map((item, index) => {
                                return (<Swiper.Item key={index}>
                                    <div style={{ height: "450px" }}>
                                        <Image src={item.url} onClick={(e) => {
                                            if (this.state.isClosing) {
                                                return;
                                            }
                                            // e.stopPropagation(); // 阻止向上冒泡
                                            var list = this.state.fileList.map(file => file.url).filter(url => url);
                                            this.setState({
                                                visible1: true,
                                                demoImages: list,
                                            })
                                        }} width={"100%"} height={"450px"} fit='cover' />  
                                    </div>
                                </Swiper.Item>)
                            })
                        }
                        {/* {items} */}
                    </Swiper>
                </div>

                <div>
                    <div style={{
                        width: "90%", marginLeft: "5%", marginTop: "4px", fontSize: "14px",textIndent: "2em"
                    }}>
                        <Ellipsis
                            direction='end'
                            content={this.state.albumsInfo.remark == null ? "" : this.state.albumsInfo.remark}
                            expandText='展开'
                            defaultExpanded={false}
                            collapseText='收起'
                            rows={4}
                        />
                    </div>

                    <div>
                        <div style={{ marginTop: "8px", width: "90%", marginLeft: "5%", borderBottom: "solid 2px #cdcdcd" }}>
                            <Grid columns={4}>
                                <Grid.Item span={2}>
                                    <div style={{ marginLeft: "5px" }}>
                                        {dayjs(this.state.albumsInfo.creationTime).format('YYYY年MM月DD日 HH点mm分')}
                                    </div>
                                </Grid.Item>
                                <Grid.Item span={2}>
                                    <div style={{ fontSize: "15px", textAlign: "end", lineHeight: "16px" }}>
                                        {
                                            this.state.isAdmin ?
                                                <Space wrap>
                                                    <Image src={"https://api.weibinyi.com/images/niannian/4/35-12.png"} fit='fill'
                                                        width={12} height={12} style={{ marginTop: "2px" }} onClick={() => {
                                                            this.props.navigate('/albumUpload', {
                                                                replace: true, state: {
                                                                    planetId: this.state.planetId,
                                                                    id: this.state.albumsInfo.id,
                                                                }
                                                            }); // 传递状态
                                                        }} />
                                                    <span style={{ marginRight: "15px", fontSize: "12px" }} onClick={() => {
                                                        this.props.navigate('/albumUpload', {
                                                            replace: true, state: {
                                                                planetId: this.state.planetId,
                                                                id: this.state.albumsInfo.id,
                                                            }
                                                        }); // 传递状态
                                                    }}>编辑</span>
                                                    <Image src={"https://api.weibinyi.com/images/niannian/4/35-13.png"} fit='fill'
                                                        width={12} height={12} style={{ marginTop: "2px" }} onClick={() => {
                                                            // this.setState({
                                                            //     isShow: true
                                                            // })
                                                            showDialog();
                                                        }} />
                                                    <span style={{ marginRight: "15px", fontSize: "12px" }} onClick={() => {
                                                        // this.setState({
                                                        //     isShow: true
                                                        // })
                                                        showDialog();
                                                    }}>删除</span>
                                                </Space> : null
                                        }
                                    </div>
                                </Grid.Item>
                            </Grid>
                        </div>
                    </div>
                </div>


                <div style={{ marginTop: "0px", marginBottom: "80px" }}>
                    <List header=''>

                        {
                            this.state.userAction.map((item, index) => {
                                return (<List.Item
                                    key={"1"}
                                    description={
                                        <>
                                            <Grid columns={6} gap={8}>
                                                <Grid.Item span={1}>
                                                    <div style={{ marginRight: "10%", float: "right" }}>
                                                        <Image
                                                            src={item.headImg}
                                                            style={{ borderRadius: 20 }}
                                                            fit='cover'
                                                            width={40}
                                                            height={40}
                                                        />
                                                    </div>
                                                </Grid.Item>
                                                <Grid.Item span={5}>
                                                    <div style={{ fontWeight: "600", color: "#000" }}>
                                                        {item.creatorUserName}
                                                    </div>
                                                    <div style={{ fontWeight: "600", color: "#424242" }}>
                                                        {item.remark}
                                                    </div>
                                                    <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                                        <Grid columns={6} gap={8}>
                                                            <Grid.Item span={2}>
                                                                {item.creationTime}
          </Grid.Item>
                                                            <Grid.Item span={1}>
                                                            </Grid.Item>
                                                            <Grid.Item span={1}>
                                                            </Grid.Item>
                                                            <Grid.Item span={1}>
                                                                <Image style={{ float: "left", marginTop: "3px" }}
                                                                    src={"https://api.weibinyi.com/images/niannian/1/1-18.png"}
                                                                    fit='fill' width={15} height={15}
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            visible: true,
                                                                            textArea: "",
                                                                            pUserName: item.creatorUserName,
                                                                            pId: item.id,
                                                                        })
                                                                    }} />
                                                                <span style={{ marginLeft: "5px" }}
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            visible: true,
                                                                            textArea: "",
                                                                            pUserName: item.creatorUserName,
                                                                            pId: item.id,
                                                                        })
                                                                    }}>{item.yanCount}</span>
                                                            </Grid.Item>
                                                            <Grid.Item span={1}>
                                                                <Image style={{ float: "left", marginTop: "3px" }}
                                                                    src={"https://api.weibinyi.com/images/niannian/1/1-20.png"}
                                                                    fit='fill' width={15} height={15} onClick={() => {
                                                                        var data = {
                                                                            TableId: this.state.id,
                                                                            Type: 2,
                                                                            TableType: "Album",
                                                                            UserActionId: item.id,
                                                                        };
                                                                        var model = item.yanList.filter(action =>
                                                                            action.creatorUserId === this.state.userInfo.id);
                                                                        if (model.length > 0) {
                                                                            return;
                                                                        }
                                                                        this.submitForm(data)
                                                                    }} />
                                                                <span style={{ marginLeft: "5px" }} onClick={() => {
                                                                    var data = {
                                                                        TableId: this.state.id,
                                                                        Type: 2,
                                                                        TableType: "Album",
                                                                        UserActionId: item.id,
                                                                    };
                                                                    var model = item.yanList.filter(action =>
                                                                        action.creatorUserId === this.state.userInfo.id);
                                                                    if (model.length > 0) {
                                                                        return;
                                                                    }
                                                                    this.submitForm(data)
                                                                }}>{item.zanCount}</span>
                                                            </Grid.Item>
                                                        </Grid>
                                                    </div>

                                                    <div>
                                                        {
                                                            item.cUserActionDto.map(item1 => {
                                                                return (<>
                                                                    <Grid columns={6} gap={8}>
                                                                        <Grid.Item span={1}>
                                                                            <Image
                                                                                src={environment.apiEndpoint + "/NNFiles/Img/" + item1.headImg}
                                                                                style={{ borderRadius: 20 }}
                                                                                fit='cover'
                                                                                width={40}
                                                                                height={40}
                                                                            />
                                                                        </Grid.Item>
                                                                        <Grid.Item span={5}>
                                                                            <div>
                                                                                <span style={{ marginRight: "5px", color: "#000", fontWeight: "600" }}>
                                                                                    {item1.creatorUserName}
                                                                                </span>
                                                                                回复
                                                                                <span style={{ marginLeft: "5px", color: "#000", fontWeight: "600" }}>
                                                                                    {item1.userActionName}
                                                                                </span>：
                                                                            </div>
                                                                            <span style={{ fontWeight: "600", color: "#424242" }}>
                                                                                {item1.remark}
                                                                            </span>
                                                                        </Grid.Item>
                                                                    </Grid>
                                                                    <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                                                        <Grid columns={6} gap={8}>
                                                                            <Grid.Item span={1}>
                                                                            </Grid.Item>
                                                                            <Grid.Item span={2}>
                                                                                {/* 2天前 */}
                                                                                {this.formatTimeDifference(new Date(item1.creationTime))}
                                                                            </Grid.Item>
                                                                            <Grid.Item span={1}>
                                                                            </Grid.Item>
                                                                            {/* <Grid.Item span={1}>
                                                                                <Image style={{ float: "left", marginTop: "3px" }}
                                                                                    src={"https://api.weibinyi.com/images/niannian/1/1-18.png"}
                                                                                    fit='fill' width={15} height={15} onClick={() => {
                                                                                        this.setState({
                                                                                            visible: true,
                                                                                            textArea: "",
                                                                                            pUserName: item1.creatorUserName,
                                                                                            pId: item1.id,
                                                                                        })
                                                                                    }} />
                                                                                <span style={{ marginLeft: "5px" }}>12</span>
                                                                            </Grid.Item>
                                                                            <Grid.Item span={1}>
                                                                                <Image style={{ float: "left", marginTop: "3px" }}
                                                                                    src={"https://api.weibinyi.com/images/niannian/1/1-20.png"}
                                                                                    fit='fill' width={15} height={15} />
                                                                                <span style={{ marginLeft: "5px" }}>12</span>
                                                                            </Grid.Item> */}
                                                                        </Grid>
                                                                    </div>
                                                                </>)
                                                            })
                                                        }
                                                    </div>

                                                </Grid.Item>
                                            </Grid>
                                        </>
                                    }
                                >
                                </List.Item>)
                            })
                        }

                    </List>

                    {
                        this.state.userAction.length == 0 ?
                            <div style={{
                                textAlign: "center", fontSize: "20px", marginTop: "10%", paddingBottom: "7%"
                            }}>
                                暂无留言信息
                                </div>
                            : ""
                    }
                </div>


                {
                    this.state.isShow ?
                        <div style={{
                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/41-18.png')"
                            , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "100%"
                            , position: "fixed", height: "100%", width: "100%", top: "0px",
                        }} onClick={() => {
                            this.setState({ isShow: false }); // 点击大 div 隐藏模糊层
                        }}>

                            <div>
                                <div style={{
                                    color: "#fff", fontSize: "15px", textAlign: "center", marginTop: "60%", marginBottom: "5%"
                                }} onClick={(e) => e.stopPropagation()}>
                                    确认删除此段回忆？
                        </div>

                                <Grid columns={2}>
                                    <Grid.Item span={1}>
                                        <div style={{
                                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/41-19.png')"
                                            , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                            , width: "70%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                            , fontWeight: "600", color: "#fff", float: "right"
                                        }} onClick={(e) => {
                                            e.stopPropagation(); // 阻止事件冒泡

                                        }}>
                                            删 除
                            </div>
                                    </Grid.Item>
                                    <Grid.Item span={1}>
                                        <div style={{
                                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/41-20.png')"
                                            , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                            , marginLeft: "5%", width: "70%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                            , fontWeight: "600", color: "rgb(125 125 125)"
                                        }} onClick={(e) => {
                                            e.stopPropagation(); // 阻止事件冒泡
                                            this.setState({ isShow: false }); // 点击取消隐藏模糊层
                                        }}>
                                            取 消
                                        </div>
                                    </Grid.Item>
                                </Grid>
                            </div>

                        </div>
                        : null
                }

                <FloatingBubble
                    axis='xy'
                    magnetic='x'
                    style={{
                        '--initial-position-bottom': '22%',
                        '--initial-position-right': '24px',
                        '--edge-distance': '24px',
                        '--background': '#ffffff00',
                        '--size': '40px'
                    }}
                    onClick={() => {
                        this.setState({
                            visible: true,
                        })
                    }}
                >
                    <Image src={"https://api.weibinyi.com/images/niannian/1/1-15.png"} fit='fill' width={40} height={40} />
                </FloatingBubble>

                <Popup
                    visible={this.state.visible}
                    onMaskClick={() => {
                        this.setState({
                            visible: false,
                            textArea: "",
                            pUserName: "",
                            pId: null,
                        })
                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '18px',
                        borderTopRightRadius: '18px',
                        minHeight: '40vh',
                    }}
                >
                    <div style={{
                        backgroundImage: this.state.titleTab == 0 ?
                            "url('https://api.weibinyi.com/images/niannian/3/5-9-25.png')" : ""
                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", minHeight: "40vh"
                    }}>

                        <div className="liuyan" style={{ width: "94%", marginLeft: "3%" }}>
                            <div style={{
                                marginTop: "20px", fontSize: "16px", marginLeft: "5px", fontWeight: "600", marginBottom: "13px"
                            }}>
                                请输入您的留言信息：
                                </div>

                            <div>
                                <TextArea placeholder={this.state.pUserName == ""
                                    ? "请输入您的留言信息" : ('回复：' + this.state.pUserName)}
                                    defaultValue={this.state.textArea}
                                    maxLength={500} rows={6} showCount value={this.state.textArea}
                                    style={{
                                        border: 'solid 1px #c7c7c7', marginTop: '5px', borderRadius: '3%',
                                        marginBottom: '5px', padding: "10px"
                                    }} onChange={(e) => {
                                        this.setState({
                                            textArea: e
                                        })
                                    }}
                                />
                            </div>

                            <div style={{
                                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/46-10.png')"
                                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                , fontWeight: "600", color: "#fff", marginTop: "15px"
                            }} onClick={() => {
                                var data = {
                                    TableId: this.state.id,
                                    Type: 1,
                                    Remark: this.state.textArea,
                                    TableType: "Album",
                                    UserActionId: this.state.pId,
                                };
                                this.submitForm(data)
                            }}>
                                提 交
                            </div>

                        </div>
                    </div>
                </Popup>

                {
                    this.state.visible1 ?
                        <ImageViewer.Multi
                            images={this.state.demoImages}
                            visible={this.state.visible1}
                            defaultIndex={0}
                            onClose={() => {
                                // 标记为正在关闭
                                this.setState({ isClosing: true, visible1: false }, () => {
                                    // 短暂延迟后重置标记，避免影响正常打开
                                    setTimeout(() => {
                                        this.setState({ isClosing: false });
                                    }, 300);
                                });
                            }}
                        /> : null
                }

                <BottomMenu  position="absolute" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);